/* Family Travel Tool — age-based packing suggestions.
   Age groups match the backend's derived traveler.age_group (from DOB, never exposing the date). */

export const AGE_GROUPS = [
  { id: "infant", label: "Infant (0\u20131)", items: [
    "Diapers + wipes (more than you think)",
    "Formula / bottles / baby food",
    "Pacifier + comfort blanket",
    "Baby carrier or sling",
    "Stroller (gate-check friendly)",
    "Portable changing pad",
    "Infant medication (fever reducer, saline drops)",
    "2\u20133 extra outfits per travel day",
    "Burp cloths + bibs",
    "Approved infant car seat",
    "Bottle-cleaning supplies / sterilizer bags",
  ]},
  { id: "toddler", label: "Toddler (2\u20134)", items: [
    "Diapers / pull-ups + wipes",
    "Sippy cup + spill-proof snacks",
    "Favorite toy + comfort blanket",
    "Lightweight stroller",
    "Tablet + toddler headphones",
    "2 extra outfits per travel day",
    "Child medication (fever reducer, band-aids)",
    "Toddler car seat / restraint",
    "Swim diapers (beach or pool trips)",
    "Small books / quiet toys for the flight",
  ]},
  { id: "child", label: "Child (5\u201311)", items: [
    "Snacks + refillable water bottle",
    "Tablet or games + kids' headphones",
    "Coloring / activity books",
    "Extra clothing layers",
    "Children's medication",
    "Motion-sickness bands or tablets",
    "ID card with parent contact in their pocket",
    "Small backpack they can carry themselves",
    "Booster seat, if needed at destination",
  ]},
  { id: "teen", label: "Teen (12\u201317)", items: [
    "Phone + charger + power bank (carry-on only!)",
    "Headphones",
    "Snacks",
    "Hoodie / extra layer for the plane",
    "Their own toiletries kit",
    "Book / downloaded entertainment",
    "Debit or prepaid card for spending money",
    "Any personal medication",
  ]},
];

export const AGE_GROUP_LABEL = Object.fromEntries(AGE_GROUPS.map((g) => [g.id, g.label]));
